import { connect } from "react-redux";

import { actions as userActions } from "../user";

import ModalSellSheet from "./ModalSellSheet.view";

const mapStateToProps = state => ({
  files: state?.selectFilesChosen || [],
  user: state.login.user,
});

const mapDispatchToProps = dispatch => ({
  updateUser: user => dispatch(userActions.update(user)),
});

export default connect(mapStateToProps, mapDispatchToProps)(ModalSellSheet);
